<template>
  <div class="popup__container" :class="[{ sloted: mustShowExtendedPopup }, !showHeaderIcon ? 'popup__container--large' : '']">
    <div class="popup" :class="[{ sloted: mustShowExtendedPopup }, modifierClass ? `popup--${modifierClass}` : '']">
      <!-- Header + icon -->
      <template v-if="!mustShowExtendedPopup">
        <div class="popup__header">
          <Moles :color="color" />
          <div v-if="showCloseIcon" class="popup__close" @click="closePopup()"></div>
        </div>
        <div class="popup__icon-container" v-if="showHeaderIcon">
          <i :style="icon" class="icon popup__icon" />
        </div>
      </template>
      <!-- Pre-body -->
      <div v-if="mustShowExtendedPopup && showCloseIcon" class="popup__close" @click="closePopup()"></div>
      <div v-if="mustShowExtendedPopup" class="popup__pre-body" :class="color ? `popup--${color}` : ''">
        <!-- Before -->
        <slot name="before" />
      </div>
      <!-- Body -->
      <div class="popup__body" :class="{ sloted: mustShowExtendedPopup }">
        <h2 class="popup__title" :class="{ sloted: mustShowExtendedPopup }">{{ title }}</h2>
        <p class="popup__subtitle" :class="[isGrey, { sloted: mustShowExtendedPopup }]" v-if="subtitle">
          {{ subtitle }}
        </p>
        <slot />
        <a v-if="!!cta && !!cta.link" class="popup__cta" :href="cta.link" target="_blank">{{ cta.title }}</a>
        <button v-if="!!cta && !!cta.action" class="popup__cta" @click="handleCtaAction()">{{ cta.title }}</button>
      </div>
      <div class="popup__backdrop" @click="closePopup()"></div>
    </div>
  </div>
</template>

<script>
const HELP = 'help';
const RESTART = 'restart';
const EMAIL_CONFIRMATION = 'email_confirmation';
const EXIT = 'exit';
const WE_CALL_YOU = 'we_call_you';
const DETAIL = 'detail';
const DETAIL_SUCCESS = 'detail_success';
const VIABILITY_CERT = 'viability_cert';
const CONTACT = 'contact';
const CONTACT_WARNING = 'contact_warning';
const SUCCESS = 'success';

import Moles from '@/funnels/components/layout/Moles';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

export default {
  components: { Moles },
  props: {
    title: {
      type: String,
      default: 'Ventana emergente',
    },
    subtitle: {
      type: String,
      default: null,
    },
    modifierClass: {
      type: String,
      default: null,
    },
    showCloseIcon: {
      type: Boolean,
      default: false,
    },
    showHeaderIcon: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
    },
    cta: {
      type: Object,
      default: null,
    },
  },
  computed: {
    icon() {
      if (this.modifierClass === HELP) return "background-image: url('/img/web/icons/faq.svg')";
      else if (this.modifierClass === RESTART) return "background-image: url('/img/web/icons/restart.svg')";
      else if (this.modifierClass === EMAIL_CONFIRMATION) return "background-image: url('/img/web/icons/alert-green.svg')";
      else if (this.modifierClass === EXIT) return "background-image: url('/img/web/icons/alert-blue.svg')";
      else if (this.modifierClass === WE_CALL_YOU) return "background-image: url('/img/web/icons/phone-blue.svg')";
      else if (this.modifierClass === CONTACT) return "background-image: url('/img/web/icons/phone-yellow.svg')";
      else if (this.modifierClass === CONTACT_WARNING) return "background-image: url('/img/web/icons/mail-warning.svg')";
      else if (this.modifierClass === DETAIL) return "background-image: url('/img/web/icons/mail.svg')";
      else if (this.modifierClass === DETAIL_SUCCESS) return "background-image: url('/img/web/icons/mail-success.svg')";
      else if (this.modifierClass === VIABILITY_CERT) return "background-image: url('/img/web/icons/cert.svg')";
      else if (this.modifierClass === SUCCESS) return "background-image: url('/img/web/icons/completed.svg')";
      else return "background-image: url('/img/web/icons/alert.svg')";
    },
    isGrey() {
      return this.modifierClass === HELP || this.modifierClass === WE_CALL_YOU ? 'text-neutral-medium' : 'text-neutral-darkest';
    },
    hasBeforeSlot() {
      return typeof this.$slots?.before !== 'undefined';
    },
    isGteXlScreen() {
      const xlSize = parseInt(fullConfig.theme.screens.xl.replace('px', ''));
      return this.windowWidth >= xlSize;
    },
    mustShowExtendedPopup() {
      return this.hasBeforeSlot && this.isGteXlScreen;
    },
  },
  methods: {
    closePopup() {
      this.$emit('closePopup');
    },
    resetMainHeader() {
      const headerEl = document.querySelector('#main-header');

      if (headerEl && headerEl.classList.contains('header--menu-shadow')) {
        headerEl.classList.add('header--menu-scroll_up');
      }
    },
    removeBodyScroll() {
      document.body.style.overflow = 'hidden';
    },
    addBodyScroll() {
      document.body.style.overflow = 'auto';
    },
    handleCtaAction() {
      this.closePopup();
      this.cta.action();
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };

    this.removeBodyScroll();
    this.resetMainHeader();
  },
  destroyed() {
    this.addBodyScroll();
  },
};
</script>
